import { ApolloLink } from "@apollo/client";
import { isDateString, mapValuesDeep } from "../../index";

export const makeRehydrateDatesLink = () => {
  return new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
      if (response.data) {
        // biome-ignore lint/suspicious/noExplicitAny: legacy code
        const r = mapValuesDeep(response.data, (value: any) =>
          isDateString(value) ? new Date(value) : value,
        );
        response.data = r;
      }
      return response;
    });
  });
};
